<seds-alert-core [color]="color" [close]="close" [display]="display" (hasClosed)="callHasClosed()">
  <div header>{{ headerTitle }}</div>
  <div content *ngIf="contentText">{{ contentText }}</div>
  <div content *ngIf="!contentText"><ng-content></ng-content></div>
</seds-alert-core>
